import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  useUploady,
  useBatchProgressListener,
  useAbortBatch,
  useUploadyContext,
  useItemStartListener,
  useItemFinishListener,
  useAllAbortListener,
  useItemFinalizeListener,
  useBatchAddListener,
} from "@rpldy/uploady";
import loadImage from "blueimp-load-image";
import imageCompression from "browser-image-compression";
import { useParams } from "react-router-dom";

import {
  currentUploadStatus,
  getFolderDetails,
  getGalleryImages,
  openMinimizedBox,
  uploadModalAction,
  clearThumbs,
  updateActiveIndex,
} from "../../store/slices/Gallery/gallerySlice";
import { updateAllUploadedImages } from "../../store/slices/Gallery/fileUploadSlice";

let stopCompression = false;

export const useUploadModal = () => {
  var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif|\.svg|\.avif|\.heic)$/i;

  const [duplicateImages, setDuplicateImages] = useState([]);
  const [invalidImages, setInvalidImages] = useState([]);
  const [files, setFiles] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [isQuited, setIsQuited] = useState(false);
  const [fileIndex, setFileIndex] = useState(0);
  const [images, setImages] = useState([]);
  const [uploadIndex, setUploadIndex] = useState(0);
  const [allFiles, setAllFiles] = useState([]);
  const [uploadAlert, setUploadAlert] = useState(false);

  const [isUploadingProgress, setIsUploadingprogress] = useState(false);
  const uploady = useUploady();
  const dispatch = useDispatch();
  const { abort } = useUploadyContext();
  const { folderID } = useParams();
  const fileUploadState = useSelector((state) => state.fileUpload);
  const { openUploadModal, openMiniBox } = useSelector(
    (state) => state.gallery
  );

  useEffect(() => {
    if (!isUploading) {
      compressedUpload(0);
    }
  }, [files]);

  const handleDragOver = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.stopPropagation();
    e.preventDefault();
    let imgArry = [...e.dataTransfer.files];
    handleFiles(imgArry);
  };
  const handleDragOut = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };
  const handleImageChange = (e) => {
    handleFiles(e.target.files);
  };

  const handleFiles = (upldFiles) => {
    let tempArr = [...upldFiles];
    tempArr.forEach((item) => {
      if (
        fileUploadState?.allUploadedImages?.some(
          (obj) => obj.name === item.name
        )
      ) {
        setDuplicateImages((state) => [
          ...state,
          { name: item?.name, duplicate: true },
        ]);
      } else if (!allowedExtensions.test(item?.name)) {
        setInvalidImages((state) => [
          ...state,
          { name: item?.name, invalid: true },
        ]);
      } else {
        setAllFiles((state) => [...state, item]);
        setFiles((state) => [...state, item]);
      }
    });
  };

  const compressedUpload = async (index) => {
    if (files.length === 0 || stopCompression) {
      return;
    }

    if (files.length > 0) {
      if (isUploading === false) {
        setIsUploading(true);
      }
      if (index < files?.length) {
        handleImageUpload(files[index]).then((r) => {
          compressedUpload(index + 1);
          setFileIndex((prevState) => prevState + 1);
        });
      } else {
        setFiles([]);
        setIsUploading(false);
      }
    }
  };

  useItemFinishListener((item) => {
    if (fileUploadState.uploadMode == "photoFind") {
      if (item.uploadResponse.data.success === true) {
        addCompletedImages(item);
      } else {
        // addDuplicate(item?.file?.name);
      }
    }
  });
  useItemStartListener((item) => {
    if (isQuited) {
      abort(item.id);
      setImages([]);
    } else {
      setIsUploadingprogress(true);
    }
    dispatch(currentUploadStatus(true));
  });
  useAllAbortListener(() => {
    setIsUploadingprogress(false);
  });
  useItemFinishListener((item) => {
    setIsUploadingprogress(false);
    dispatch(currentUploadStatus(false));
  });
  useItemFinalizeListener((item) => {
    setIsUploadingprogress(false);
    dispatch(currentUploadStatus(false));
  });

  useBatchAddListener((batch) => {
    if (fileUploadState.uploadMode == "photoFind") {
      setImages((state) => [...state, ...batch?.items]);
    }
  });

  const addCompletedImages = (item) => {
    images.forEach((img, i) => {
      if (img?.file?.name === item?.file?.name) {
        images[i] = {
          ...images[i],
          thumbnail:
            item?.uploadResponse?.data?.result?.image_info?.src
              ?.thumbnail_small,
        };
      }
    });
    if (!isQuited) {
      setUploadIndex((prevState) => prevState + 1);
    }
    setImages([...images]);

    dispatch(updateAllUploadedImages(item));
  };

  const handleImageUpload = async (imageFile) => {
    const options = {
      maxSizeMB: 3,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };

    try {
      let compressedFile = await imageCompression(imageFile, {
        ...options,
        alwaysKeepResolution: true,
        initialQuality: 1,
      });
      loadImage.parseMetaData(imageFile, (data) => {
        if (data?.exif) {
          uploady.upload(compressedFile, {
            destination: {
              params: {
                exif: JSON.stringify(data?.exif?.getAll()),
                album_id: folderID,
                // image_name:
              },
              filesParamName: "image",
            },
          });
        } else {
          uploady.upload(compressedFile, {
            destination: {
              params: { album_id: folderID },
              filesParamName: "image",
            },
          });
        }
      });

      return true;
    } catch (error) {
      uploady.upload(imageFile, {
        destination: {
          params: { album_id: folderID },
          filesParamName: "image",
        },
      });

      return true;
    }
  };

  const closeUploadModalWhenDone = async () => {
    if (images?.length > 0) {
      let obj = {
        url: "/album/album-images",
        id: folderID,
        page: 1,
        sort: "desc",
        per_page: 20,
      };

      await dispatch(getGalleryImages(obj))
        .unwrap()
        .then(() => {
          dispatch(uploadModalAction(false));
        });

      let data = {
        id: folderID,
        url: "/album/get-album",
      };
      await dispatch(getFolderDetails(data));
    } else {
      dispatch(uploadModalAction(false));
    }
    setUploadIndex(0);
    setFileIndex(0);
    setImages([]);
    setFiles([]);
    setAllFiles([]);
    setDuplicateImages([]);
    setInvalidImages([]);

    setIsUploading(false);

    dispatch(updateActiveIndex(0));
    dispatch(clearThumbs());
  };

  const closeUploadModal = async () => {
    if (uploadIndex == images?.length) {
      closeUploadModalWhenDone();
    } else if (isUploadingProgress) {
      await dispatch(openMinimizedBox(true));
      dispatch(uploadModalAction(false));
    }
  };
  const handleCloseMiniMizedModal = async () => {
    if (isUploadingProgress) {
      setUploadAlert(true);
    } else {
      let obj = {
        id: folderID,
        url: "/album/get-album",
      };
      await dispatch(getFolderDetails(obj));

      await dispatch(uploadModalAction(false));
      dispatch(openMinimizedBox(false));
      closeUploadModalWhenDone();
      setIsUploadingprogress(false);
    }
  };

  const handleQuitUploading = async () => {
    setFiles([]);
    setIsQuited(true);
    stopCompression = true;
    setAllFiles([]);
    setUploadIndex(0);
    setImages([]);
    setIsUploadingprogress(false);
    let obj = {
      id: folderID,
      url: "/album/get-album",
    };
    await dispatch(getFolderDetails(obj));
    let data = {
      url: "/album/album-images",
      id: folderID,
      page: 1,
      sort: "desc",
      per_page: 20,
    };

    await dispatch(getGalleryImages(data))
      .unwrap()
      .then(() => {
        dispatch(uploadModalAction(false));
      });
    dispatch(openMinimizedBox(false));
    setUploadAlert(false);
  };

  return {
    handleDragOver,
    handleDrop,
    handleDragOut,
    handleImageChange,
    handleQuitUploading,
    handleCloseMiniMizedModal,
    images,
    allFiles,
    duplicateImages,
    invalidImages,
    fileIndex,
    uploadIndex,
    openMiniBox,
    closeUploadModal,
    openUploadModal,
    uploadAlert,
    setUploadAlert,
  };
};
